var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    d: "M6.66667 8.33333V24.6667C6.66667 25.3808 7.26395 25.9781 7.97807 25.9781H24.6667C25.3808 25.9781 25.9781 25.3808 25.9781 24.6667V8.33333H6.66667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9DDE5",
    d: "M24.6667 7.97809H9.33333C8.6192 7.97809 8.02191 8.57538 8.02191 9.28951V24.6667C8.02191 25.3808 8.6192 25.9781 9.33333 25.9781H24.6667C25.3808 25.9781 25.9781 25.3808 25.9781 24.6667V9.28951C25.9781 8.57538 25.3808 7.97809 24.6667 7.97809Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.6667 10.6667H23.3333V24H10.6667V10.6667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9DDE5",
    d: "M13.3333 18.6667H23.3333V24H13.3333V18.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.1efb39d6bde476b67e43ae07d178941e.svg";
export { ForwardRef as ReactComponent };